/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixPayDetailsStatus = exports.ValueType = exports.Transparency = exports.StructNullValue = exports.SortOrder = exports.SessionType = exports.SessionStatus = exports.Platform = exports.OnlineConferenceConferenceType = exports.LocationsLocationType = exports.LocationStatus = exports.LocationLocationType = exports.InvoiceDetailsStatus = exports.DayOfWeek = exports.CheckoutStatus = exports.CalendarType = exports.CalendarConferenceConferenceType = exports.BookingStatus = exports.ApprovalStatus = exports.Actor = void 0;
var Actor;
(function (Actor) {
    Actor["UNDEFINED_ACTOR"] = "UNDEFINED_ACTOR";
    Actor["BUSINESS"] = "BUSINESS";
    Actor["CUSTOMER"] = "CUSTOMER";
})(Actor = exports.Actor || (exports.Actor = {}));
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["UNDEFINED"] = "UNDEFINED";
    BookingStatus["PENDING_CHECKOUT"] = "PENDING_CHECKOUT";
    BookingStatus["CONFIRMED"] = "CONFIRMED";
    BookingStatus["CANCELED"] = "CANCELED";
    BookingStatus["PENDING"] = "PENDING";
    BookingStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    BookingStatus["DECLINED"] = "DECLINED";
})(BookingStatus = exports.BookingStatus || (exports.BookingStatus = {}));
var CalendarConferenceConferenceType;
(function (CalendarConferenceConferenceType) {
    CalendarConferenceConferenceType["UNDEFINED"] = "UNDEFINED";
    CalendarConferenceConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    CalendarConferenceConferenceType["CUSTOM"] = "CUSTOM";
})(CalendarConferenceConferenceType = exports.CalendarConferenceConferenceType || (exports.CalendarConferenceConferenceType = {}));
var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    CalendarType["OUTLOOK"] = "OUTLOOK";
    CalendarType["OFFICE_365"] = "OFFICE_365";
})(CalendarType = exports.CalendarType || (exports.CalendarType = {}));
var CheckoutStatus;
(function (CheckoutStatus) {
    CheckoutStatus["UNDEFINED"] = "UNDEFINED";
    CheckoutStatus["COMPLETE"] = "COMPLETE";
    CheckoutStatus["PENDING_CASHIER"] = "PENDING_CASHIER";
    CheckoutStatus["REJECTED"] = "REJECTED";
    CheckoutStatus["READY"] = "READY";
    CheckoutStatus["CANCELED"] = "CANCELED";
    CheckoutStatus["REFUNDED"] = "REFUNDED";
    CheckoutStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    CheckoutStatus["WIX_PAY_FAILURE"] = "WIX_PAY_FAILURE";
    CheckoutStatus["PENDING_MARK_AS_PAID"] = "PENDING_MARK_AS_PAID";
    CheckoutStatus["PENDING_BUYER"] = "PENDING_BUYER";
})(CheckoutStatus = exports.CheckoutStatus || (exports.CheckoutStatus = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var InvoiceDetailsStatus;
(function (InvoiceDetailsStatus) {
    InvoiceDetailsStatus["UNDEFINED"] = "UNDEFINED";
    InvoiceDetailsStatus["CREATED"] = "CREATED";
    InvoiceDetailsStatus["VOIDED"] = "VOIDED";
    InvoiceDetailsStatus["DELETED"] = "DELETED";
    InvoiceDetailsStatus["SENT"] = "SENT";
    InvoiceDetailsStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    InvoiceDetailsStatus["PAID"] = "PAID";
})(InvoiceDetailsStatus = exports.InvoiceDetailsStatus || (exports.InvoiceDetailsStatus = {}));
var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNDEFINED"] = "UNDEFINED";
    LocationLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationLocationType["CUSTOM"] = "CUSTOM";
})(LocationLocationType = exports.LocationLocationType || (exports.LocationLocationType = {}));
var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus = exports.LocationStatus || (exports.LocationStatus = {}));
var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
})(LocationsLocationType = exports.LocationsLocationType || (exports.LocationsLocationType = {}));
var OnlineConferenceConferenceType;
(function (OnlineConferenceConferenceType) {
    OnlineConferenceConferenceType["UNDEFINED"] = "UNDEFINED";
    OnlineConferenceConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    OnlineConferenceConferenceType["CUSTOM"] = "CUSTOM";
})(OnlineConferenceConferenceType = exports.OnlineConferenceConferenceType || (exports.OnlineConferenceConferenceType = {}));
var Platform;
(function (Platform) {
    Platform["UNDEFINED_PLATFORM"] = "UNDEFINED_PLATFORM";
    Platform["WEB"] = "WEB";
    Platform["MOBILE_APP"] = "MOBILE_APP";
})(Platform = exports.Platform || (exports.Platform = {}));
var SessionStatus;
(function (SessionStatus) {
    SessionStatus["UNDEFINED"] = "UNDEFINED";
    SessionStatus["CONFIRMED"] = "CONFIRMED";
    SessionStatus["CANCELLED"] = "CANCELLED";
})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
var SessionType;
(function (SessionType) {
    SessionType["UNDEFINED"] = "UNDEFINED";
    SessionType["EVENT"] = "EVENT";
    SessionType["WORKING_HOURS"] = "WORKING_HOURS";
    SessionType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    SessionType["AVAILABILITY"] = "AVAILABILITY";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var StructNullValue;
(function (StructNullValue) {
    StructNullValue["NULL_VALUE"] = "NULL_VALUE";
})(StructNullValue = exports.StructNullValue || (exports.StructNullValue = {}));
var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    Transparency["FREE"] = "FREE";
    Transparency["BUSY"] = "BUSY";
})(Transparency = exports.Transparency || (exports.Transparency = {}));
var ValueType;
(function (ValueType) {
    ValueType["SHORT_TEXT"] = "SHORT_TEXT";
    ValueType["LONG_TEXT"] = "LONG_TEXT";
    ValueType["CHECK_BOX"] = "CHECK_BOX";
})(ValueType = exports.ValueType || (exports.ValueType = {}));
var WixPayDetailsStatus;
(function (WixPayDetailsStatus) {
    WixPayDetailsStatus["UNDEFINED"] = "UNDEFINED";
    WixPayDetailsStatus["CREATED"] = "CREATED";
    WixPayDetailsStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    WixPayDetailsStatus["COMPLETE"] = "COMPLETE";
    WixPayDetailsStatus["FAILED"] = "FAILED";
    WixPayDetailsStatus["DECLINED"] = "DECLINED";
    WixPayDetailsStatus["PENDING_MARK_AS_PAID"] = "PENDING_MARK_AS_PAID";
    WixPayDetailsStatus["CANCELED"] = "CANCELED";
})(WixPayDetailsStatus = exports.WixPayDetailsStatus || (exports.WixPayDetailsStatus = {}));
//# sourceMappingURL=types.js.map